import { selectFileSliceDispatch } from "../../Constants/ReduxConstants";

interface SelectFileState {
    selectedFilesList: string[],
    selectedFileTemplate: string,
    open: boolean,
    apiResponse: string,
    apiSuccess: boolean,
    isTemplate: boolean,
    isDataModel: boolean
}

//Every reducer needs initial state.
const initialState: SelectFileState = {
    selectedFilesList: [],
    selectedFileTemplate: "",
    open: false,
    apiResponse: "",
    apiSuccess: false,
    isTemplate: false,
    isDataModel: false
}

export default function selectFileSlice(state = initialState, action: { type: any; payload: any; }) {
    switch (action.type) {
        case selectFileSliceDispatch.setSelectedFilesList: {
            return {
                ...state,
                selectedFilesList: action.payload
            }
        }
        case selectFileSliceDispatch.setSelectedFileTemplate: {
            return {
                ...state,
                selectedFileTemplate: action.payload
            }
        }
        case selectFileSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case selectFileSliceDispatch.setApiResponse: {
            return {
                ...state,
                apiResponse: action.payload
            }
        }
        case selectFileSliceDispatch.setApiSuccess: {
            return {
                ...state,
                apiSuccess: action.payload
            }
        }
        case selectFileSliceDispatch.setIsTemplate: {
            return {
                ...state,
                isTemplate: action.payload
            }
        }
        case selectFileSliceDispatch.setIsDataModel: {
            return {
                ...state,
                isDataModel: action.payload
            }
        }
        default:
            return state
    }
}